import React, {Component} from 'react'
import {getDashboard} from './../modules/Api'
import {Card, Row, Col, Icon} from 'antd'
import {Chart} from 'react-google-charts'
import './home.css'
import ACL from './ACL';

const MyChart = (props) => {
    return (
        <Chart
            width={'100%'}
            height={'300px'}
            chartType="AreaChart"
            loader={<Icon type="loading" style={{ fontSize: 35, textAlign: 'center', marginTop: 100, width: '100%' }} spin />}
            data={props.data}
            options={{
            annotations: {
                boxStyle: {
                    margin: 'auto',
                    boxShadow: '5px 5px'
                }
            },
            title: props.title,
            hAxis: { title: props.hAxis.title, titleTextStyle: { italic: false, fontSize: 16, fontName:'iransans', color: (props.hAxis.color ? props.hAxis.color : '#333') } },
            vAxis: { minValue: 0 },
            // For the legend to fit, we make the chart area smaller
            chartArea: { width: '70%', height: '70%' },
            // lineWidth: 25
            }}
            // For tests
            rootProps={{ 'data-testid': '1' }}
        />
    )
}

class Home extends Component {
    constructor() {
        super();
        this.state = {
            dashboardData: false,
        }
    }

    componentWillMount() {
        this.fetchData();
    }
    fetchData = (query = '') => {
        getDashboard(query, (data) => {this.setState({
            dashboardData: data.data,
        })});
    }

    render() {
        if(this.state.dashboardData) {
            const deepLink = this.state.dashboardData.deep_link

            return (
                <ACL component="div" has_permission="dashboard_charts" denied={() => {return 'شما به جزییات داشبورد دسترسی ندارید!'}} >
                    <Row>
                        <Col span={8} style={{float: 'right'}}>
                            <Card className={'card-with-shadow'} bordered={false}>
                                <Icon className={'header-icon-dashboard'} type="user" />
                                <div>
                                    <span className={'bold'}>کل کاربران: </span>{this.state.dashboardData.users.total}
                                </div>
                                <div>
                                    <span className={'bold'}>ثبت‌نام‌های امروز: </span>{this.state.dashboardData.users.registered_today}
                                </div>
                                <div>
                                    <span className={'bold'}>ثبت‌نام‌های امروز با شماره معتبر: </span>{this.state.dashboardData.users.valid_phone_today}
                                </div>
                            </Card>
                        </Col>
                        <Col span={8} style={{float: 'right'}}>
                            <Card className={'card-with-shadow'} bordered={false}>
                                <Icon className={'header-icon-dashboard'} type="user" />
                                <div>
                                    <span className={'bold'}>کل کاربران بات: </span>{this.state.dashboardData.bots.total}
                                </div>
                                <div>
                                    <span className={'bold'}>ثبت‌نام‌های امروز بات: </span>{this.state.dashboardData.bots.registered_today}
                                </div>
                            </Card>
                        </Col>
                        <Col span={8} style={{float: 'right'}}>
                            <Card className={'card-with-shadow'} bordered={false}>
                                <Icon className={'header-icon-dashboard'} type="user" />
                                <div>
                                    <span className={'bold'}> کاربران نوتیفیکیشن وب: </span>{this.state.dashboardData.fcm.web}
                                </div>
                                <div>
                                    <span className={'bold'}> کاربران نوتیفیکیشن موبایل: </span>{this.state.dashboardData.fcm.mobile}
                                </div>
                       
                                <div>
                                    <span className={'bold'}>ثبت‌نام‌های این هفته نوتیفیکیشن وب: </span>{this.state.dashboardData.fcm.last_week_web}
                                </div>
                                <div>
                                    <span className={'bold'}>ثبت‌نام‌های این هفته نوتیفیکیشن موبایل: </span>{this.state.dashboardData.fcm.last_week_mobile}
                                </div>
                                <div>
                                    <span className={'bold'}>ثبت‌نام‌های امروز نوتیفیکیشن: </span>{this.state.dashboardData.fcm.today}
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Card className={'card-with-shadow'} bordered={false}>
                                <MyChart data={[
                                    ['روز', 'send', 'view', 'click','unsubscribe'],
                                    ...this.state.dashboardData.subscribers
                                ]}
                                hAxis={{title: 'مشترکین'}}
                                />
                            </Card>
                        </Col>
                        <Col span={24}>
                            <Card className={'card-with-shadow'} bordered={false}>
                                <MyChart data={[
                                    ['روز', 'send'],
                                    ...this.state.dashboardData.newsletters
                                ]}
                                hAxis={{title: 'خبرنامه‌ها'}}
                                />
                            </Card>
                        </Col>
                        <Col span={24}>
                            <Card className={'card-with-shadow'} bordered={false}>
                                <MyChart data={[
                                    ['روز', 'registered-in-site','registered-in-bot', 'blocked-the-bot'],
                                    ...this.state.dashboardData.users.registered
                                ]}
                                hAxis={{title: 'کاربران'}}
                                />
                            </Card>
                        </Col>
                        <Col span={24}>
                            <Card className={'card-with-shadow'} bordered={false}>
                                <MyChart data={[
                                    ['روز', 'added'],
                                    ...this.state.dashboardData.brands
                                ]}
                                hAxis={{title: 'برندها'}}
                                />
                            </Card>
                        </Col>
                        <Col span={24}>
                            <Card className={'card-with-shadow'} bordered={false}>
                                <MyChart data={[
                                    ['روز', 'add','delete'],
                                    ...this.state.dashboardData.bots.favorite
                                ]}
                                hAxis={{title: 'علاقه‌مندی‌های بات'}}
                                />
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{direction:'ltr', 'textAlign': 'left'}}>
                        <Card className={'card-with-shadow'}>
                            <h4 className="ant-card-head-title" style={{direction:'rtl', width: '100%', 'textAlign': 'right'}}>داده های روزانه</h4>

                            <ul>
                            {Object.keys(deepLink.details).map((value, index) => {
                                return <li key={index}>
                                    {value}
                                    <ul>
                                        {Object.keys(deepLink.details[value]).map((value2, index) => {
                                            return <li key={index}> {value2} : {deepLink.details[value][value2]} </li>
                                        })}
                                    </ul>
                                </li>
                            })}
                            </ul>
                        </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={24} style={{direction:'ltr', 'textAlign': 'left'}}>
                        <Card className={'card-with-shadow'}>
                            <h4 className="ant-card-head-title" style={{direction:'rtl', width: '100%', 'textAlign': 'right'}}>به صورت کلی</h4>

                            <ul>
                                {Object.keys(deepLink.overall).map((value, index) => {
                                    return <li key={index}> {value} : {deepLink.overall[value]} </li>
                                })}
                            </ul>
                        </Card>
                        </Col>
                    </Row>
                </ACL>
            )
        }

        return (
            <div></div>
        )
    }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js